<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>
<div *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div *ngIf="_element?.headerText" [froalaView]="_element?.headerText" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">{{_element?.description}}</div>
    </div>
    <div *ngIf="_element.type != 'DRAGGABLE'" class="new-options new-options__full-width">

      <div class="fill-in-the-blank-input pre-wrap" style="display: block;">
        <ng-container *ngFor=" let text of texts; let i=index">
          <p style="display: inline;" [innerHtml]="text"></p>
          <div class="fill-in-the-blank-input--blank" *ngIf="i!==texts.length-1" style="display: inline;">
            <input [style.width]=" resize(value[i])" placeholder="Type in your answer here" type="text"
              [(ngModel)]="value[i]" (change)='focusout(i)'>
          </div>
        </ng-container>
      </div>

    </div>
    <div *ngIf="_element.type == 'DRAGGABLE'" class="new-options new-options__full-width">
      <div class="draggable-input pre-wrap">
        <ng-container *ngFor=" let text of texts; let i=index">
          <span [innerHTML]=" text | textFormat:'%'"></span>
          <div *ngIf="i!==texts.length-1" class="form-control--selectoption d-inline-block">
            <select [(ngModel)]="value[i]" (change)='focusout(i)' class="form-control">
              <option disabled hidden [value]="''">Choose an option</option>
              <option *ngFor="let opt of copyAllOptions;index as j" [value]="opt">{{opt}}
              </option>
            </select>
          </div>
        </ng-container>
      </div>
    </div>
    <app-exercise-navigation-bar [id]="id" [questionAttempted]="questionAttempted" (onNext)="next()"
      (onSubmit)="next(true)"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div *ngIf="_element?.headerText" [froalaView]="_element?.headerText" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">{{_element?.description}}</div>
    </div>
    <div *ngIf="_element.type != 'DRAGGABLE'" class="new-options new-options__full-width">
      <div class="fill-in-the-blank-input pre-wrap">
        <ng-container *ngFor=" let text of texts; let i=index">
          {{text}}
          <div class="fill-in-the-blank-input--blank"
            [class.new-options--wrong-answer]="!corrects[i] && questionChecked"
            [class.new-options--has-feedback]="!corrects[i] && questionChecked"
            [class.new-options--right-answer]="corrects[i] && questionChecked" *ngIf="i!==texts.length-1">
            <input [class.disabled]="questionChecked" [style.width]=" resize(value[i])"
              placeholder="Type in your answer here" type="text" [(ngModel)]="value[i]" (change)='focusout(i)'>
            <div *ngIf="_element?.options[i].feedback && !corrects[i] && questionChecked" class="has-feedback">
              <span class="has-feedback--icon">
                <span>?</span>
              </span>
              <div class="has-feedback--dropdown">
                {{_element.options[i].feedback}}
              </div>
            </div>
          </div>
        </ng-container>
      </div>

    </div>
    <div *ngIf="_element.type == 'DRAGGABLE'" class="new-options new-options__full-width">
      <div class="draggable-input pre-wrap">
        <ng-container *ngFor=" let text of texts; let i=index">
          <span [innerHTML]=" text | textFormat:'%'"></span>
          <div *ngIf="i!==texts.length-1" class="form-control--selectoption d-inline-block"
            [class.new-options--wrong-answer]="!corrects[i] && questionChecked"
            [class.new-options--right-answer]="corrects[i] && questionChecked"
            [class.new-options--has-feedback]="questionChecked && !corrects[i]">
            <select [(ngModel)]="value[i]" (change)='focusout(i)' [attr.disabled]="questionChecked ? '' : null"
              class="form-control">
              <option disabled hidden [value]="''">Choose an option</option>
              <option *ngFor="let opt of copyAllOptions;index as j" [value]="opt">{{opt}}
              </option>
            </select>

            <div *ngIf="_element?.options[i].feedback && !corrects[i] && questionChecked" class="has-feedback">
              <span class="has-feedback--icon">
                <span>?</span>
              </span>
              <div class="has-feedback--dropdown">
                {{_element.options[i].feedback}}
              </div>
            </div>
          </div>

        </ng-container>
      </div>
    </div>
    <div *ngIf="questionAttempted && questionChecked &&  _element?.isFeedbackEnabled" class="overall-feedback pb-0">

      <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
   <app-exercise-navigation-bar [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="questionAttempted"
      (onReview)="check()" (onNext)="next()" (onSubmit)="next(true)" [questionChecked]="questionChecked"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="isSubmitted" [class.new-options--not-answered]="!_answer" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container">
    <div class="new-question--titleBox"
      [class.score-applied]="_element?.isScoring &&  _answer && points  && isResultPublished">
      <div *ngIf="_element?.headerText" [froalaView]="_element?.headerText" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <!-- <span *ngIf="!isPractice && _element?.isScoring &&  _answer && points  && isResultPublished && !isTouchstone"
        class="answer-point">Points:
        {{(points?points.point:0 ) | number:'1.0-2'}} out of
        {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
    </div>
    <div *ngIf="_element.type != 'DRAGGABLE'" class="new-options new-options__full-width">
      <div class="new-question__container">
        <div class="fill-in-the-blank-input pre-wrap" style="display: block;">
          <ng-container *ngFor=" let text of texts; let i=index">
            <p style="display: inline;" [innerHtml]="text"></p>
            <div *ngIf="i!==texts.length-1" class="fill-in-the-blank-input--blank"
              [class.new-options--wrong-answer]="!corrects[i] && isResultPublished"
              [class.new-options--has-feedback]="!corrects[i] && isResultPublished"
              [class.new-options--right-answer]="corrects[i] && isResultPublished">
              <input class="disabled" [style.width]="resize(value[i])" placeholder="Type in your answer here"
                type="text" [(ngModel)]="value[i]">
              <div *ngIf="_element?.options[i].feedback && !corrects[i] && isResultPublished" class="has-feedback">
                <span class="has-feedback--icon">
                  <span>?</span>
                </span>
                <div class="has-feedback--dropdown">
                  {{_element.options[i].feedback}}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div *ngIf="_element.type == 'DRAGGABLE'" class="new-options new-options__full-width">
      <div class="draggable-input pre-wrap">
        <div class="new-question__container">
          <ng-container *ngFor=" let text of texts; let i=index">
            <span [innerHTML]=" text | textFormat:'%'"></span>
            <span *ngIf="i!==texts.length-1" class="draggable-input--blank" [class.empty]="!value[i]"
              [class.new-options--wrong-answer]="!corrects[i] && isResultPublished"
              [class.new-options--has-feedback]="!corrects[i] && isResultPublished"
              [class.new-options--right-answer]="corrects[i] && isResultPublished">
              {{ value[i] || 'Not Answered' }}
              <div *ngIf="_element?.options[i].feedback && !corrects[i] && isResultPublished" class="has-feedback">
                <span class="has-feedback--icon">
                  <span>?</span>
                </span>
                <div class="has-feedback--dropdown">
                  {{_element.options[i].feedback}}
                </div>
              </div>
            </span>
          </ng-container>
        </div>
      </div>
    </div>
     <!-- thrive -->
     <ng-container *ngIf="questionBlos && questionBlos.length">     
      <h5 class="question__thrive">Thrive Skills:</h5>
      <div class="question__thrive-list">
        <ul>
          <ng-container *ngFor="let blo of questionBlos">
            <li [innerHTML]="blo.shortStatement"></li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <div *ngIf="_element?.isFeedbackEnabled" class="overall-feedback">
      <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
      <div class="new-question__container">
        <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
      </div>
    </div>
  </div>

  <!-- <app-like-dislike [id]="id" *ngIf="_element?.isFeedbackEnabled" [userFeedback]="userFeedback" [_element]="_element"
    (reportFeedback)="_reportFeedback($event)" (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>
